export default __webpack_public_path__ + "static/media/Helm of Brutal Carnage.620495af.jpg";